import { Area } from '@/shared/model/enumerations/area';
import { Programa } from '@/shared/model/programa.model';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ProgramaResumenComponent extends Vue {
  @Prop({ required: false })
  public programa: Programa;

  public nombreInstitucion = '';
  public nombreSede = '';
  public nombreDependencia = '';

  public mounted(): void {
    this.watchPrograma();
  }

  @Watch('programa')
  private watchPrograma(): void {
    this.nombreDependencia = '';
    this.nombreSede = '';
    this.nombreInstitucion = '';

    if (this.isPosgrado) {
      (this.programa?.instituciones ?? []).forEach(institucion => {
        (institucion.sedes ?? []).forEach(sede => {
          if (sede.postulante) {
            this.nombreInstitucion = institucion.nombreInstitucion;
            this.nombreSede = sede.sede;
            this.nombreDependencia = sede.nombreDependencia;
          }
        });
      });
    } else {
      if (this.programa?.instituciones?.length) {
        this.nombreInstitucion = this.programa.instituciones[0].nombreInstitucion;
      }
    }
  }

  get isPosgrado() {
    return this.programa?.area === Area.POSGRADOS;
  }
}
